export default {"src":"/_next/static/media/Icon-Travel-Management.f0e362c6.svg","height":26,"width":24,"blurWidth":0,"blurHeight":0};